import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../common/Icon';
import Loading from '../../common/Loading';
import { ServiceNowCustomFormProps } from './types';

function ServiceNowCustomForm({ isLoading, handleChange, clientId }: ServiceNowCustomFormProps) {
    const [localClientId, setLocalClientId] = useState(clientId || '');

    useEffect(() => {
        if (handleChange && localClientId !== clientId) {
            handleChange(localClientId);
        }
    }, [localClientId, clientId, handleChange]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newClientId = event?.target?.value || '';
        setLocalClientId(newClientId);
    };

    return (
        <div className="ast-app-status-form__section">
            <Loading isLoaded={!isLoading}>
                <div className="sg-form-group">
                    <div className="sg-form-group__header">
                        <h3 className="sg-form-group__title">
                            ServiceNow Client ID
                            <span
                                className="sg-form-group__tooltip ast-client-id__tooltip"
                                data-tooltip="Client ID is required for External Ticket Details integration"
                            >
                                <Icon alias="info" />
                            </span>
                        </h3>
                    </div>
                    <div className="sg-form-group__content sg-form-group__content--bordered">
                        <div className="sg-form-group__row">
                            <div className="ast-client-id__input-container">
                                <input
                                    id="clientId"
                                    type="text"
                                    value={localClientId}
                                    onChange={handleInputChange}
                                    placeholder="Enter your Adobe Sign Client ID"
                                    className="ast-client-id__input"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Loading>
        </div>
    );
}

ServiceNowCustomForm.propTypes = {
    appId: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired,
    clientId: PropTypes.string,
};

export default ServiceNowCustomForm;
